import { mapGetters } from 'vuex';
import { getLuminance } from '@/utils/index';
import * as WhiteLabel from '@/store/white-label';

const ELEVATION_08 = '0px 0px 2px rgba(0, 0, 0, 0.24), 0px 8px 10px 1px ' +
  'rgba(0, 0, 0, 0.05), 0px 3px 14px 2px rgba(0, 0, 0, 0.06), 0px 5px 5px -3px rgba(0, 0, 0, 0.1)';

export default {
  computed: {
    ...mapGetters(WhiteLabel.type, {
      whiteLabel: WhiteLabel.WHITE_LABEL
    }),
    cssVars() {
      const {
        primaryColor, backgroundUrl
      } = this.whiteLabel;
      let isPrimaryColorDark = true;

      const iframeMode = this.$route.query.iframe === 'true';
      const backgroundUrlToSet = iframeMode ? '' : (backgroundUrl || '');

      if (primaryColor) {
        const luminance = getLuminance(primaryColor);
        if (luminance > 180) { isPrimaryColorDark = false; }
      }

      const primaryColorToSet = primaryColor || '#0049FF';
      const primaryTextColor = isPrimaryColorDark ? primaryColorToSet : '#212529';

      return {
        '--primary-color': primaryColorToSet,
        '--background-image-url': backgroundUrlToSet,
        '--primary-text-color': primaryTextColor,
        '--primary-border-color': primaryColor ? primaryTextColor : '#0049FF',
        '--primary-text-color-internal': isPrimaryColorDark ? 'white' : '#212529',
        '--elevation-08': backgroundUrlToSet ? ELEVATION_08 : null
      };
    }
  }
};
